import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, HeadphonesIcon, HandCoins, PlayCircle, HelpCircle } from "lucide-react";
import SEO from "../components/SEO";

const SECTIONS = [
  {
    icon: Users,
    title: "Community",
    desc: "Connect with thousands of candidates and professionals preparing for interviews. Share experiences, tips, and real interview questions — and reach out for general support anytime.",
    cta: "Join the community",
    href: "https://discord.gg/t9CrSPRYV",
    external: true,
  },
  {
    icon: HeadphonesIcon,
    title: "Support",
    desc: "Need help with Project Wingman? Our support team is available to assist with account issues, technical questions, and anything else you need to succeed.",
    cta: "Get support",
    href: "#",
    external: true,
  },
  {
    icon: HandCoins,
    title: "Earn with us",
    desc: "Share your referral code and earn 20 bonus interview minutes OR ₹200 cash for every friend who joins. No cap — refer as many people as you want.",
    cta: "Start earning",
    internal: "/app/referral",
  },
  {
    icon: PlayCircle,
    title: "Demo",
    desc: "See Project Wingman in action. Watch a full walkthrough of Live Mode, Mock Mode, and Coding Assistant — and see how candidates land offers using it.",
    cta: "Watch demo",
    href: "#",
    external: true,
  },
];

const FAQ_SECTION = {
  icon: HelpCircle,
  title: "FAQ",
  desc: "Got questions? Browse answers to the most common questions about Wingman AI — setup, features, pricing, privacy, and more.",
  cta: "Browse FAQ",
  internal: "/app/faq",
};

export default function ResourceHub() {
  const nav = useNavigate();
  return (
    <div className="px-10 py-10 max-w-5xl">
      <SEO title="Resource Hub — Interview Guides & Tips" description="Access interview guides, coaching tips, community support, and everything you need to ace your next job interview with Project Wingman." path="/app/resources" />
      <h1 className="font-display text-5xl font-black tracking-tighter mb-2">Resources</h1>
      <p className="text-neutral-500 mb-10">Everything you need to get the most out of Project Wingman.</p>
      <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10" data-testid="resources-grid">
        {SECTIONS.map((s) => (
          <div
            key={s.title}
            className="bg-[#0A0A0A] hover:bg-[#0F0F0F] p-8 transition group flex flex-col cursor-pointer"
            onClick={() => s.internal ? nav(s.internal) : s.href && s.href !== "#" && window.open(s.href, "_blank")}
          >
            <s.icon className="w-6 h-6 text-[#D3FF24] mb-5" strokeWidth={1.5} />
            <h3 className="font-display font-semibold text-xl mb-3 group-hover:text-[#D3FF24] transition">{s.title}</h3>
            <p className="text-sm text-neutral-400 leading-relaxed flex-1 mb-6">{s.desc}</p>
            <span className="text-xs uppercase tracking-widest font-semibold text-[#D3FF24] hover:underline">{s.cta} →</span>
          </div>
        ))}
        <div className="bg-[#0A0A0A] hover:bg-[#0F0F0F] p-8 transition group flex flex-col cursor-pointer" onClick={() => nav(FAQ_SECTION.internal)}>
          <FAQ_SECTION.icon className="w-6 h-6 text-[#D3FF24] mb-5" strokeWidth={1.5} />
          <h3 className="font-display font-semibold text-xl mb-3 group-hover:text-[#D3FF24] transition">{FAQ_SECTION.title}</h3>
          <p className="text-sm text-neutral-400 leading-relaxed flex-1 mb-6">{FAQ_SECTION.desc}</p>
          <span className="text-xs uppercase tracking-widest font-semibold text-[#D3FF24] hover:underline">{FAQ_SECTION.cta} →</span>
        </div>
      </div>
    </div>
  );
}
